export enum EServerErrorCode {
  SUCCESS = 200,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  TIMEOUT = 408,
  INTERNAL_SERVER_ERROR = 500,
  BAD_GATEWAY = 502,
  WRONG_DATA_REQUEST = 422,
  EXPECTATION = 417,
  UNAVAILABLE = 503,
}
